import { createSlice } from '@reduxjs/toolkit';

const playerSlice = createSlice({
    name: 'player',
    initialState: {
        totalGamesPlayed: 0,
        totalGamesCompleted: 0,
        wins: 0,
        losses: 0,
        winningPercentage: 0,
        saves: 0,
        savesPerGame: 0,
        halfcups: 0,
        halfcupsPerGame: 0,
        fullCups: 0,
        fullCupsPerGame: 0,
        totalCups: 0,
        totalCupsPerGame: 0,
        ownCups: 0,
        ownCupsPerGame: 0,
        lapsGiven: 0,
        lapsReceived: 0,
        totalCupsFor: 0,
        totalCupsAgainst: 0,
        cups: []
    },
    reducers: {
        // This will merge the current state with the payload
        setPlayerStats: (state, action) => {
            return { ...state, ...action.payload }; 
        },
        resetPlayerStats: (state) => {
            // Reset only the four specified fields to their initial values
            state.totalGamesPlayed = 0;
            state.totalGamesCompleted = 0;
            state.wins = 0;
            state.losses = 0;
            state.winningPercentage = 0;
            state.saves = 0;
            state.savesPerGame = 0;
            state.halfcups = 0;
            state.halfcupsPerGame = 0;
            state.fullCups = 0;
            state.fullCupsPerGame = 0;
            state.totalCups = 0;
            state.totalCupsPerGame = 0;
            state.ownCups = 0;
            state.ownCupsPerGame = 0;
            state.lapsGiven = 0;
            state.lapsReceived = 0;
            state.totalCupsFor = 0;
            state.totalCupsAgainst = 0;
            state.cups = [];
        },
    },
});

// Export actions for use in components
export const { setPlayerStats, resetPlayerStats } = playerSlice.actions;

// Export the reducer to be included in the store
export default playerSlice.reducer;